export const LOGIN_ENDPOINT = 'users/login';
export const ALLANNOUNCEMENTS_ENDPOINT = 'announcement/content';
export const ADDANNOUNCEMENT_ENDPOINT = 'announcement/content';
export const ALLPORTTERMINALS_ENDPOINT = 'terminal/list';
export const DELETEANNOUNCEMENT_ENDPOINT = 'announcement/content';
export const ADVERTISEMENTS_ENDPOINT = 'advertisement/content';
export const ADDADVERTISEMENT_ENDPOINT = 'advertisement/content';
export const UPDATEADDVERTISEMENT_ENDPOINT = 'advertisement/content';
export const UPDATEANNOUNCEMENT_ENDPOINT = 'announcement/content';
export const UPLOAD_ENDPOINT= 'advertisement/documents';
export const DOWNLOAD_ENDPOINT= 'advertisement/documents';
export const ALLROLES_ENDPOINT = 'users/roles';
export const DELETEADVERTISEMENT_ENDPOINT = 'advertisement/content';
export const ADDROLE_ENDPOINT = 'users/roles';
export const ADDSUBSCRIPTION_ENDPOINT = 'subscribe/basePlans';
export const ALLSUBSCRIPTIONS_ENDPOINT = 'subscribe/basePlans';
export const DELETEROLE_ENDPOINT = 'users/roles';
export const UPDATEROLE_ENDPOINT = "users/roles";
export const ASSIGNROLE_ENDPOINT = "users/";
export const PROFILEAPPROVAL = "workflows/document/admin/tasks";
export const SINGLEPROFILEAPPROVAL = "workflows/profile/admin/tasks";
export const PROFILEAPPROVALHISTORY_ENDPOINT = "users/profileApprovalHistory";
export const USERPROFILEAPPROVAL = "workflows/reviewProfile";
export const ALLUSERROLELIST_ENDPOINT = "users/usersRole";
export const TILEPREMISSION_ENDPOINT = "adminConfig/permission";
export const CREATETILE_ENDPOINT = "adminConfig/permission";
export const UPDATETILE_ENDPOINT = "adminConfig/permission";
export const GETLOOKUPDATA_ENDPOINT = "adminConfig/lookup";
export const ADDLOOKUPDATA_ENDPOINT = "adminConfig/lookup";
export const UPDATELOOKUPDATA_ENDPOINT = "adminConfig/lookup";
export const ADVERTISEMENTSLOT_ENDPOINT = "advertisement/slot";
export const GET_TERMS_AND_CONDITION = "adminConfig/termsAndConditions";
export const POST_TERMS_AND_CONDITIONS = "adminConfig/termsAndConditions";
export const ALLUSERLIST_ENDPOINT = "users/";
export const TRANSACTIONDISCOUNT_ENDPOINT = "services/transactionDiscount";
export const TRANSACTIONFEES_ENDPOINT = "services/transactionFees";
export const GETPROXYDETAIL_ENDPOINT = "services/proxy";
export const PROXYDOCUMENTACTION_ENDPOINT = "services/proxy";
export const PENALTYPOLICY_ENDPOINT = "services/penaltyPolicy";
export const CONFIGURESERVICE_ENDPOINT = "services/configureService";
export const REQUESTERFIELDS_ENDPOINT = "services/fields";
export const SERVICETYPEDROPDOWN_ENDPOINT = "services/serviceTypes"